const LOAD_SOURCES = "LOAD_SOURCES";
const LOAD_SOURCES_SUCCESS = "LOAD_SOURCES_SUCCESS";
const LOAD_SOURCES_FAIL = "LOAD_SOURCES_FAIL";

const SOURCES_POST = "SOURCES_POST";
const SOURCES_PUT = "SOURCES_PUT";
const SOURCES_DELETE = "SOURCES_DELETE";

export default function source(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
    message: "",
  },
  action,
) {
  switch (action.type) {
    case LOAD_SOURCES: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_SOURCES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_SOURCES_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }
    default:
      return state;
  }
}

export function getSources() {
  return {
    type: LOAD_SOURCES,
    payload: {
      request: {
        url: "Source/",
      },
    },
  };
}

export function addSource(source) {
  return {
    type: SOURCES_POST,
    payload: {
      request: {
        url: "Source",
        method: "POST",
        data: source,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getSources());
        },
      },
    },
  };
}

export function editSource(source, id) {
  return {
    type: SOURCES_PUT,
    payload: {
      request: {
        url: "Source/" + id,
        method: "PUT",
        data: source,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getSources());
        },
      },
    },
  };
}

export function deleteSource(id) {
  return {
    type: SOURCES_DELETE,
    payload: {
      request: {
        url: "Source/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getSources());
        },
      },
    },
  };
}
